module.exports = __webpack_public_path__ + "img/spIcon2.98a3737e.png";